import React, {Component} from "react";
import ReactDOM from "react-dom";
import Overlay from '../../components/Overlay'
import { Helmet } from 'react-helmet'
import { compose, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

export const Donate = () => {
  let self = this

  function validateSum () {
  if (document.form.sum.value< 10) {
  	document.getElementById('errorSum').innerHTML = 'Минимальная сумма для пожертвования - 10 рублей<br>';
    } else {
  	  document.getElementById('errorSum').innerHTML = '';
    }
  }
  
  function validateCheck () {
    if (!document.form.agreement.checked) {
  	  document.getElementById('errorCheck').innerHTML = 'Необходимо согласие с условиями публичной оферты<br>';
    } else {
  	  document.getElementById('errorCheck').innerHTML = '';
    }
  }
  
  function cloudPay(name, sum) {
    name = document.form.name.value;
    sum = document.form.sum.value;
    let agreement = document.form.agreement.checked;
  
    if (agreement && (sum >= 10)) {
      var widget = new window.cp.CloudPayments();
      widget.charge({ // options
          publicId: 'pk_7982a193c348b543483b57bfc1fc5',  //id из личного кабинета
          description: 'Пожертвование', //назначение
          amount: Number(sum),//10, //сумма
          currency: 'RUB', //валюта
          invoiceId: '1234567', //номер заказа  (необязательно)
          accountId: name,//'user@example.com', //идентификатор плательщика (необязательно)
          skin: "mini", //дизайн виджета
          data: {
          }
        },
        function (options) { // success
           var win = window.open("https://www.brd.ru/info/charity", '_self')
    	   win.focus();
    	   return (true)
        },
        function (reason, options) { // fail
        });
    } else {
      if (sum < 10) {
        document.getElementById('errorSum').innerHTML = 'Минимальная сумма для пожертвования - 10 рублей<br>';
        console.log('Минимальная сумма для пожертвования - 10 рублей');
      }
      if (!agreement) {
        document.getElementById('errorCheck').innerHTML = 'Необходимо согласие с условиями публичной оферты<br>';
        console.log('Необходимо согласие с условиями публичной оферты');
      }
    }
  }

  return (
  <div className='Donate'>
  <div className='Container Container_light'>
    <Helmet>
      <title>Пожертвовать MFC</title>
    </Helmet>
    <Overlay isActive={true}>
      <div className="mfc-modal-content donate">
        <form name='form'>
        <div className="mfc-modal__input-wrapper">
          <label htmlFor="name">Имя</label>
          <input
            className='mfc-modal__input'
            type="text"
            name="name"
            id="name"
            placeholder="Кому мы благодарны"
          />
        </div>
        <div className="mfc-modal__input-wrapper">
          <label htmlFor="sum">Сумма пожертвования</label>
          <input
            className='mfc-modal__input'
            type="number"
            name="sum"
            id="sum"
            min="10"
			onChange={validateSum}
			required
			placeholder="Введите сумму"
          />
        </div>
        <div className="mfc-modal__checkbox-wrapper">
          <div className="checkbox">
            <input className="custom-checkbox" type="checkbox" id="color-1" name="agreement" value="indigo" onChange={validateCheck} />
              <label htmlFor="color-1">Согласен с условиями&nbsp;
                <a href="http://static.businessforcharity.today/pravila.pdf" target="_blank" className="mfc-modal__link">
                  публичной оферты
                </a>
              </label>
          </div>
          <span id='errorSum' className='error'></span>
          <span id='errorCheck' className='error'></span>
        </div>
          <a className='mfc-modal__btn-submit' onClick={cloudPay}>Помогаю!</a>
        </form>
        <div className="mfc-modal__thanks">
          <b>Спасибо!</b><br />
          #КаждыйВкладИмеетЗначение
        </div>
        <div className="mfc-modal__logo-list">
          <div className="Header__logo-img">
            <a href="https://businessforcharity.today/" alt="businessforcharity.today" title="businessforcharity.today">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1396.45 222" className="Header__logo-img">
                <polygon fill='white' className='LeftSide'
                         points="514.33 74.23 454.2 74.23 454.2 109.8 507.25 109.8 507.25 122.45 454.2 122.45 454.2 175.15 439.09 175.15 439.09 61.1 514.33 61.1 514.33 74.23"/>
                <path fill='white' className='RightSide'
                      d="M880.23,549c0,28-14.63,44.37-39.87,44.37-25.4,0-40.51-16.34-40.51-43.57s15.59-44,40.67-44,39.71,15.86,39.71,43.25m-66.23.48c0,20.35,9.8,32.36,26.52,32.36,16.08,0,25.73-12.17,25.73-32.52,0-19.7-10-32.19-26-32.19S814,529.78,814,549.48"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M939.71,520.33a26.22,26.22,0,0,0-3.54-.16c-22.51,0-26.52,17.14-26.52,35.72v34.92H896V508.16h13v17.78c5.79-13.94,15.92-19.71,30.71-19.71Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M1035.7,594.65c-47.51,0-78.61-35.07-78.61-89.13,0-48,28-89.86,80.05-89.86,33,0,66.32,20.66,70.18,55.5h-16.4c-5.31-25.47-26.29-41.32-54.26-41.32-38.1,0-63.42,30.27-63.42,75.68s24.84,75.2,62.94,75.2c34.48,0,53.53-23.55,57.15-55.5h16.16c-3.62,42.28-32.56,69.43-73.79,69.43"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M1146.62,490.62c8.92-17.78,22.43-26.43,42.92-26.43,28.94,0,43.4,16.58,43.4,44.93v81.69h-15.19V511c0-21.14-9.88-34.11-31.83-34.11-28.21,0-39.06,22.1-39.06,48.77v65.11h-14.95V419.74h14.95c0,74.72,0,61.51-.24,70.88"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M1370.15,590.09a34.33,34.33,0,0,1-12.06,1.92c-14.71,0-16.15-11.29-16.15-22.58-10.13,16.1-25.8,24.74-46.78,24.74-25.32,0-40.51-13-40.51-34.59,0-22.59,15.43-35.08,46-38.2,19.53-1.93,30.14-2.41,36.17-6.49,3.14-2.17,4.34-5.53,4.34-11.78,0-20.42-12.54-26.66-32.31-26.66-21,0-31.83,9.13-33.76,29.07h-14.47c1.21-26.43,19.29-41.57,49.92-41.57,28,0,45.57,12.25,45.57,35.56v67.27c0,7.45-.24,12.5,8.2,12.5a18.06,18.06,0,0,0,5.79-.72Zm-62.7-57.9c-15.67,2.16-36.89,5.76-36.89,25.94,0,14.42,11.09,23.55,28.46,23.55,22.66,0,42.19-14.41,42.19-38V523.54c-4.82,5.28-17.12,6.48-33.76,8.65"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M1450,480.77c-1.69,0-3.14-.24-4.1-.24-18.57,0-34.73,11.53-39.55,29.31-1.93,7.45-2.89,14.66-2.89,30.52v50.45h-15V467.32h14.22v29.55c10.37-22.59,22.19-31,47.27-31.48Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M1477.93,443.77h-15.19V419h15.19Zm0,147h-15.19V467.32h15.19Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M1556.55,479.57H1531v78.32c0,12.5-.48,20.67,15.68,20.67a90.74,90.74,0,0,0,9.89-.72v13a84.3,84.3,0,0,1-13.27,1c-10.85,0-22.91-2.16-25.8-14.17-1.2-5.05-1.45-8.65-1.45-27.15V479.57h-21.94V467.32H1516V429.59h15v37.73h25.57Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='RightSide'
                      d="M1626.23,595.37c-10.85,28.84-16.64,42.29-36.65,42.29a80.34,80.34,0,0,1-13.27-1.2V623.24c5.79,1.45,7.48,1.69,10.86,1.69,14.71,0,18.8-14.66,26.52-35.08l-49.91-122.53h16.64l33.51,85.05c4.34,11.29,2.65,7.21,7.48,21.86,3.86-12.49,5.3-17.78,7.47-23.54l30.63-83.37h15.43Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide'
                      d="M278.49,519.51h33.7q10,0,16.35,4.45t6.35,13.45a15.4,15.4,0,0,1-2.6,8.85,16.45,16.45,0,0,1-7.1,5.85q13,3.69,13,17.4,0,10.1-6.8,15.65t-17.3,5.55h-35.6Zm15.2,12.1v16.7h14.2q11.81,0,11.8-8.3c0-3.27-1.06-5.49-3.2-6.65a17.92,17.92,0,0,0-8.6-1.75Zm0,27.3v19.4h15.7q6.11,0,9.65-2c2.37-1.34,3.55-3.9,3.55-7.7s-1.25-6.45-3.75-7.75-5.91-2-10.25-2Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide'
                      d="M395.59,539.11v51.6h-13.5v-7.3a19.21,19.21,0,0,1-16.8,8.8q-8.49,0-13.25-4.65t-4.75-13.75v-34.7h14.3v29.5a35.55,35.55,0,0,0,.25,4.65,13.73,13.73,0,0,0,1.05,3.55,5.19,5.19,0,0,0,2.65,2.65,11.57,11.57,0,0,0,4.75.85q11.2,0,11.2-14.6v-26.6Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide'
                      d="M449.79,554.11h-13.2c-.4-2.6-1.38-4.44-2.95-5.5s-3.85-1.6-6.85-1.6a10.89,10.89,0,0,0-5.9,1.35,4.23,4.23,0,0,0-2.1,3.75,4,4,0,0,0,2.4,3.9,46.74,46.74,0,0,0,8.6,2.4l1.6.3q3.6.69,5.75,1.25a41.26,41.26,0,0,1,5.25,1.8,15.7,15.7,0,0,1,4.8,2.8,14,14,0,0,1,3,4.15,13.18,13.18,0,0,1,1.3,6,15.13,15.13,0,0,1-6.3,12.8q-6.3,4.69-17.3,4.7-10.5,0-17.3-4.5t-6.9-13.8h13.5q.71,8.6,11,8.6a12,12,0,0,0,6.85-1.75,5.4,5.4,0,0,0,2.55-4.65,4.24,4.24,0,0,0-2.3-4.1,39.46,39.46,0,0,0-8.5-2.6c-.33-.07-.6-.14-.8-.2-.46-.14-1.5-.37-3.1-.7s-2.71-.59-3.35-.75l-3.1-.85a16.4,16.4,0,0,1-3.15-1.15c-.66-.37-1.55-.84-2.65-1.4a7.57,7.57,0,0,1-2.45-1.85c-.53-.67-1.12-1.45-1.75-2.35a8.24,8.24,0,0,1-1.3-3,18.68,18.68,0,0,1-.35-3.7,13.4,13.4,0,0,1,5.9-11.7q5.91-4.11,16.7-4.1,9.71,0,15.9,4T449.79,554.11Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide' d="M474.19,519.51v12H460v-12Zm0,19.6v51.6H460v-51.6Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide'
                      d="M533.69,590.71h-14.4v-30.1q0-5.5-1.8-8.35t-7-2.85q-11.21,0-11.2,13.6v27.7h-14.1v-51.6h13.5v7.2a20.25,20.25,0,0,1,17.1-8.6q8.3,0,13.1,4.8t4.8,13.7Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide'
                      d="M592.59,574.71a23.21,23.21,0,0,1-8.85,12.9,25.79,25.79,0,0,1-15.35,4.6q-11.89,0-19.15-7.4T542,565.21q0-12,7.3-19.8a24.37,24.37,0,0,1,18.6-7.8q11.7,0,18.6,7.95t6.9,21.55v1.4h-37q.11,6.69,3.25,10.2t8.85,3.5q7.5,0,10.5-7.5ZM579,559.51a14.55,14.55,0,0,0-3.3-8.35,9.74,9.74,0,0,0-7.8-3.25,10.57,10.57,0,0,0-7.8,3.1,13.71,13.71,0,0,0-3.7,8.5Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide'
                      d="M644.79,554.11h-13.2c-.4-2.6-1.39-4.44-3-5.5s-3.85-1.6-6.85-1.6a10.87,10.87,0,0,0-5.9,1.35,4.23,4.23,0,0,0-2.1,3.75,4,4,0,0,0,2.4,3.9,46.5,46.5,0,0,0,8.6,2.4l1.6.3c2.4.46,4.31.88,5.75,1.25a41.26,41.26,0,0,1,5.25,1.8,15.94,15.94,0,0,1,4.8,2.8,14,14,0,0,1,3,4.15,13.31,13.31,0,0,1,1.3,6,15.13,15.13,0,0,1-6.3,12.8q-6.3,4.69-17.3,4.7-10.5,0-17.3-4.5t-6.9-13.8h13.5q.69,8.6,11,8.6a12,12,0,0,0,6.85-1.75,5.4,5.4,0,0,0,2.55-4.65,4.24,4.24,0,0,0-2.3-4.1,39.85,39.85,0,0,0-8.5-2.6c-.34-.07-.6-.14-.8-.2-.47-.14-1.5-.37-3.1-.7s-2.72-.59-3.35-.75l-3.1-.85a15.89,15.89,0,0,1-3.15-1.15c-.67-.37-1.55-.84-2.65-1.4a7.57,7.57,0,0,1-2.45-1.85c-.54-.67-1.12-1.45-1.75-2.35a7.93,7.93,0,0,1-1.3-3,18,18,0,0,1-.35-3.7,13.37,13.37,0,0,1,5.9-11.7q5.89-4.11,16.7-4.1,9.69,0,15.9,4T644.79,554.11Z"
                      transform="translate(-278.49 -415.66)"/>
                <path fill='white' className='LeftSide'
                      d="M698.19,554.11H685c-.4-2.6-1.39-4.44-3-5.5s-3.85-1.6-6.85-1.6a10.87,10.87,0,0,0-5.9,1.35,4.23,4.23,0,0,0-2.1,3.75,4,4,0,0,0,2.4,3.9,46.5,46.5,0,0,0,8.6,2.4l1.6.3c2.4.46,4.31.88,5.75,1.25a41.26,41.26,0,0,1,5.25,1.8,15.94,15.94,0,0,1,4.8,2.8,14,14,0,0,1,3,4.15,13.31,13.31,0,0,1,1.3,6,15.13,15.13,0,0,1-6.3,12.8q-6.3,4.69-17.3,4.7-10.5,0-17.3-4.5t-6.9-13.8h13.5q.69,8.6,11,8.6a12,12,0,0,0,6.85-1.75,5.4,5.4,0,0,0,2.55-4.65,4.24,4.24,0,0,0-2.3-4.1,39.85,39.85,0,0,0-8.5-2.6c-.34-.07-.6-.14-.8-.2-.47-.14-1.5-.37-3.1-.7s-2.72-.59-3.35-.75l-3.1-.85a15.89,15.89,0,0,1-3.15-1.15c-.67-.37-1.55-.84-2.65-1.4a7.57,7.57,0,0,1-2.45-1.85c-.54-.67-1.12-1.45-1.75-2.35a7.93,7.93,0,0,1-1.3-3,18,18,0,0,1-.35-3.7,13.37,13.37,0,0,1,5.9-11.7q5.89-4.11,16.7-4.1,9.69,0,15.9,4T698.19,554.11Z"
                      transform="translate(-278.49 -415.66)"/>
              </svg>
              <img src="" width="60" alt="BFC" className="logo-item-small" />
            </a>
          </div>
        </div>
      </div>
    </Overlay>
  </div>
  </div>
)
}

export default injectIntl(compose(
)(Donate))


// WEBPACK FOOTER //
// ./src/containers/Buttons/TravliNet.jsx